import { useState, useCallback } from 'react';
import { useApiFetch } from '../api';
import { VmPowerAction, VmPowerActionResult } from '../types/models/VirtualMachine';
import { ApiResponseVmPowerAction } from '../types/api/ApiResponseVirtualMachine';

interface UseVmPowerReturn {
  sendPowerAction: (vmId: number, action: VmPowerAction) => Promise<VmPowerActionResult>;
  loading: boolean;
  error: Error | null;
}

export const useVmPower = (): UseVmPowerReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const apiFetch = useApiFetch();

  const sendPowerAction = useCallback(
    async (vmId: number, action: VmPowerAction): Promise<VmPowerActionResult> => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiFetch(`/datacenters/vms/${vmId}/power`, {
          method: 'POST',
          body: JSON.stringify({ action }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = (await response.json()) as ApiResponseVmPowerAction;
        if (data.status === 'success') {
          return data.data;
        } else {
          throw new Error(data.message || 'Power action failed');
        }
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Power action failed');
        setError(error);
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [apiFetch],
  );

  return { sendPowerAction, loading, error };
};
